import React, { useContext } from 'react';
import {GlobalContext} from "../../handlers/GlobalContext";

const LoadMore = ({loadBlog, totalPosts}) => {
    const [ state, dispatch] = useContext(GlobalContext);
    const translate = (term, alt) => {
        return state.locale.translation[term] || alt || term;
    }

    return (
        <div className="d-flex justify-content-center col-12 text-center mt-5 mt-xs-0">
            <button className={`load-blog-btn ${totalPosts ? 'disabled' : null}`}
                    onClick={() => { loadBlog() }} >
                { !totalPosts ? translate("products-info-loadMore",'LOAD MORE...').toUpperCase() : translate("products-info-noMore",'NO MORE PRODUCTS AVAILABLE').toUpperCase() }
            </button>
        </div>
    );
};
const NotAvailable = ({}) => {
    const [ state, dispatch] = useContext(GlobalContext);
    const translate = (term, alt) => {
        return state.locale.translation[term] || alt || term;
    }
    return (
        <div className="d-flex justify-content-center col-12 text-center mt-5 mt-xs-0">
            <button className={'load-blog-btn disabled'} >
                {translate("products-info-noProducts",'NO PRODUCTS AVAILABLE').toUpperCase()}
            </button>
        </div>
    );
};

export { NotAvailable };
export default LoadMore;

